module.exports = __webpack_public_path__ + "static/media/telcel.ba5dc230.svg";